import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subscriptionPlan'
})
export class SubscriptionPlanPipe implements PipeTransform {
  transform(value: any): string {
    switch (value) {
      case 'basic.monthly':
        return 'Baby Raven (Monthly)';
      case 'basic.annually':
        return 'Baby Raven (Annually)';
      case 'pro.monthly':
        return 'Mama Raven (Monthly)';
      case 'pro.annually':
        return 'Mama Raven (Annually)';
      case 'free.trial':
        return 'Trial (Free)';
      default:
        return 'Free (No Plan)';
    }
  }
}
